import axios from 'axios';

const MANUAL_RESOLVE_SIG_RE = /^Missing .+\s+(signature|initials)\s+[—-]\s+/i;

export function isManualResolvableSigIssue(issue) {
  const description = (issue?.description || '').trim();
  return MANUAL_RESOLVE_SIG_RE.test(description);
}

export async function resolveComplianceIssue({ apiUrl, issueId, resolvedBy }) {
  await axios.patch(`${apiUrl}/compliance-issues/${issueId}/resolve`, {
    resolved_by: resolvedBy || undefined,
  });
}
